import Lottie from "react-lottie";
import { Link } from "react-router-dom";
import notFoundAnimation from "../animations/notfound.json";
import { EmptyState, Page } from "../components/ui";

function NotFound() {
  return (
    <Page style={{ margin: "0 auto", paddingTop: "8vh" }}>
      <EmptyState
        title={<h1 style={{ fontSize: "22px", margin: 0 }}>Page not found</h1>}
        action={<Link to="/">Go to homepage</Link>}
      >
        That page is nowhere to be found.
      </EmptyState>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: notFoundAnimation,
        }}
        height={420}
      />
    </Page>
  );
}

export default NotFound;
